module.exports = __webpack_public_path__ + "static/media/integral_salmantina_deusto.efbf3823.png";